import { useState } from 'react';

import VisibiltySensor from 'react-visibility-sensor';

import {
  Container,
  Wrapper,
  CirclesContainer,
  BottomWrapper,
  BottomWrapperDisclaimer,
} from './styles';

import Circle from './ProgressCircle';

import GoogleWebDevIcon from '@/images/GoogleWebDev';

const Pontuacao: React.FC = () => {
  const [isVisible, setVisible] = useState(false);

  const onVisibilityChange = (event: boolean) => {
    if (isVisible) return;

    return setVisible(event);
  };

  return (
    <Container>
      <Wrapper>
        <h2>Pontuação de alta performance</h2>
        <p>
          Garantimos a alta performance e eficiência do seu app com pontuações
          acima de 80 na auditoria do Google
        </p>

        <BottomWrapper>
          <VisibiltySensor
            onChange={onVisibilityChange}
            minTopValue={150}
            scrollDelay={500}
            partialVisibility
          >
            <CirclesContainer>
              {isVisible && <Circle number={100} title="Performance" />}
              {isVisible && (
                <Circle number={93} duration={0.7} title="Acessibilidade" />
              )}
              {isVisible && (
                <Circle number={100} duration={0.9} title="Melhores práticas" />
              )}
              {isVisible && <Circle number={96} duration={1.1} title="SEO" />}
            </CirclesContainer>
          </VisibiltySensor>
          <BottomWrapperDisclaimer>
            <div>
              <GoogleWebDevIcon />
              <p>
                Dados da auditagem do site da Generoso Transportes através do
                Google Web.dev,{' '}
                <a
                  href="https://web.dev/measure/"
                  target="_blank"
                  rel="noreferrer"
                >
                  confira
                </a>
                .
              </p>
            </div>
          </BottomWrapperDisclaimer>
        </BottomWrapper>
      </Wrapper>
    </Container>
  );
};

export default Pontuacao;
